import React from 'react';

import PropTypes from 'prop-types';
import { Container, CloseBtn } from './styles';

export default function ModalImage({ image, closeModal }) {
  return (
    <Container onClick={closeModal}>
      <CloseBtn onClick={closeModal} />
      <div>
        <img src={image} alt="Passo a Passo" />
      </div>
      ;
    </Container>
  );
}
ModalImage.propTypes = {
  image: PropTypes.string,
  closeModal: PropTypes.func,
};
